/** @jsxImportSource react */
export default function TipComponent({
  children,
}: {
  children: React.ReactNode;
}) {
  return <div className='font-b-s'>{children}</div>;
}
